export default __webpack_public_path__ + "static/media/about.b5dcbace.png";